<template>
  <div id="app">
    <marketing-consent></marketing-consent>
    <notify-past-due></notify-past-due>
    <navigation></navigation>
    <router-view/>
    <footernav></footernav>
  </div>
</template>

<script>
import Navigation from 'components/Navigation.vue';
import Footer from 'components/Footer.vue';
import marketingConsent from 'components/MarketingConsent.vue';
import notifyPastDue from 'components/NotifyPastDue.vue';
import Eventbus from './eventBus.js';

export default {
  name: 'App',
  created() {
    // Set prerenderReady to true to allow Prerender to save
    window.onload = function () {
      window.prerenderReady = true;
    };
    // Remove any existing coupon codes in localStorage
    localStorage.removeItem('coupon');
    // Send pageview event when page is initially created
    ga('send', 'pageview', { page: window.location.href });
  },
  metaInfo() {
    return {
      title: 'Create imagery that gets noticed with Cinemagraph Pro | Flixel',
      meta: [
        {
          'property': 'image',
          'content': 'https://cdn.flixel.com/static/static-web/defaultImageFlixel.png',
        },
        {
          'property': 'description',
          'content': 'Flixel offers the best professional creative tools and web services for creating and sharing cinemagraphs across web, social media, digital displays, email, and more.',
        },
        {
          'property': 'ogType',
          'content': 'website',
        },
        {
          'property': 'ogTitle',
          'content': 'Create imagery that gets noticed with Cinemagraph Pro | Flixel',
        },
        {
          'property': 'ogImageUrl',
          'content': 'https://cdn.flixel.com/static/static-web/defaultImageFlixel.png',
        },
        {
          'property': 'ogDescription',
          'content': 'Flixel offers the best professional creative tools and web services for creating and sharing cinemagraphs across web, social media, digital displays, email and more.',
        },
        {
          'property': 'ogUrl',
          'content': window.location.href,
        },
        // Twitter
        {
          'property': 'twitter:card',
          'content': window.location.href,
        },
        {
          'property': 'twitter:site',
          'content': '@flixel',
        },
        {
          'property': 'twitter:creator',
          'content': '@flixel',
        },
        {
          'property': 'twitter:title',
          'content': 'Create imagery that gets noticed with Cinemagraph Pro | Flixel',
        },
        {
          'property': 'twitter:description',
          'content': 'Flixel offers the best professional creative tools and web services for creating and sharing cinemagraphs across web, social media, digital displays, email, and more.',
        },
        {
          'property': 'twitter:image:src',
          'content': 'https://cdn.flixel.com/static/static-web/defaultImageFlixel.png',
        },
        {
          'property': 'twitter:domain',
          'content': 'flixel.com',
        },
        {
          'property': 'twitter:app:name:iphone',
          'content': 'Flixel Cinemagraph Pro',
        },
        {
          'property': 'twitter:app:name:ipad',
          'content': 'Flixel Cinemagraph Pro',
        },
        {
          'property': 'twitter:app:id:ipad',
          'content': 'id642139481',
        },
        {
          'property': 'twitter:app:id:iphone',
          'content': 'id642139481',
        },
        // Social
        {
          'property': 'keywords',
          'content': 'flixel, flixels, cinemagraph, cinemagraphs, pro, plus, mac, ios, apple, design, award, living, moving, photos, gif, gifs, create, photoshop, tyra, banks, americas, next, top, model',
        },
        {
          'property': 'author',
          'content': 'Flixel.com',
        },
        // Facebook
        {
          'property': 'fb:app_id',
          'content': '239130049499290',
        },
        {
          'property': 'og:site_name',
          'content': 'Flixel',
        },
      ],
    };
  },
  watch: {
    '$route': function () {
      // Send pageview event on route change
      ga('send', 'pageview', { page: window.location.href });
      if (document.querySelector('.paddle-frame')) {
        document.querySelector('.paddle-frame').remove();
        // Remove classes that Paddle injects
        document.documentElement.removeAttribute('class');
      }
      this.account = JSON.parse(localStorage.getItem('account'));
      if (this.account !== null) {
        const merchantUrl = this.account.subscription.merchant_billing_url;
        if (this.account.subscription.past_due) {
          if (this.$cookies.get('notifyPastDueIgnored')) {
            Eventbus.$emit('triggerNotifyModal', false);
          } else {
            Eventbus.$emit('triggerNotifyModal', true);
          }
        }
      }
      // Remove disable-scrolling class on route changes
      $('body').removeClass('disable-scrolling');
    },
  },
  components: {
    'Navigation': Navigation,
    'Footernav': Footer,
    'marketing-consent': marketingConsent,
    'notify-past-due': notifyPastDue,
  },
};
</script>

<style src="./styles/app.sass" lang="sass"></style>



// WEBPACK FOOTER //
// src/App.vue